import {cloneElement} from "react";

export const toIcon =
  (icon: JSX.Element, keepColor = false) =>
  (props: JSX.IntrinsicElements["svg"]) =>
    cloneElement(icon, {...props, "data-keep": keepColor});
